<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>批量新增子账户</div>
		<div></div>
	</header>
	<div class="z-body" style="padding:10px;">
		<v-form ref="form">
			<v-text-field
				v-model="level1"
				label="一级（个）"
				required
			></v-text-field>
			<v-text-field
				v-model="level2"
				label="二级（个）"
				required
			></v-text-field>
			<v-text-field
				v-model="level3"
				label="三级（个）"
				required
			></v-text-field>
			<div class="z-btn-long" @click="onpost">提交</div>
        </v-form>
	</div>
</div>
</template>

<script>
export default {
	name: 'addSubAccount',
	data() {
		return {
			level1:1,
			level2:5,
			level3:0,
		}
	},
	created() {
	},
	methods: {
		onpost(){
			this.post('api/users/multiReg',{level1:this.level1,level2:this.level2,level3:this.level3}).then((rs)=>{
				this.$store.commit('layer',rs.msg)
				this.jump('/index/subAccount')
			})
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.z-subAccount-item {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
	padding: 10px;
	border-bottom: 1px solid #27292F;
}
.z-subAccount-user {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
}
.z-subAccount-info div:nth-child(2) {
	font-size: 10px;
	color: #9B9A9C;
}
.z-user-avatar {
	width: 35px;
	height: 35px;
	border-radius: 5px;
	margin-right: 10px;
}
.z-icon {
	width: 18px;
	height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/addSubAccount.vue